import React, { useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";

const Summary = (props) => {
  const dispatch = useDispatch();
  const { translationState } = useSelector((state) => state.user);
  const { userLanguage } = useSelector((state) => state.auth);
  const shippingCartTranslation =
    translationState?.[0]?.translations?.shippingCart?.[userLanguage];
  const walletTranslation =
    translationState?.[0]?.translations?.wallet?.[userLanguage];
  const orderTranslation =
    translationState?.[0]?.translations?.order?.[userLanguage];
  const paymentInfoTranslation =
    translationState?.[0]?.translations?.paymentInfo?.[userLanguage];

  // Yncoin Purchase Policy Translations
  const yncoinPolicyTranslations = {
    en: "Buying Yncoin is final. No refunds or chargebacks are allowed.",
    fr: "L'achat de Yncoin est définitif. Aucun remboursement ou contestation n'est autorisé.",
    es: "Comprar Yncoin es definitivo. No se permiten reembolsos ni contracargos.",
    zh: "购买Yncoin是最终决定。不允许退款或拒付。",
    pt: "Comprar Yncoin é definitivo. Não são permitidos reembolsos ou contestações.",
    ar: "شراء عملة ين نهائي. لا يُسمح بالاسترداد أو الاعتراض على الرسوم."
  };

  const {
    paymentConfiguration,
    salesPrice,
    paymentMethod,
    totalPrice,
    additionalCharge,
    bordered,
    yinnPercentage,
  } = props;
  return (
    <div
      className="summary-container"
      style={bordered && { border: "solid 1px #707070" }}
    >
      <Row>
        <Col xs="0" sm="1"></Col>
        <Col xs="12" sm="10">
          <div className="summary-title-text">
            {shippingCartTranslation?.summary
              ? shippingCartTranslation?.summary
              : "Summary"}
          </div>
          <div className="summary-description-text">
            {shippingCartTranslation?.paraLine
              ? shippingCartTranslation?.paraLine
              : "Additional charges will be added based on your payment method."}
          </div>
          <div className="summary-entry-row">
            <div className="summary-entry-text">
              {walletTranslation?.coinPrice
                ? walletTranslation?.coinPrice
                : "Coin Price"}
            </div>
            <div className="summary-entry-value">
              {salesPrice ? salesPrice : 0}
            </div>
          </div>
          <div className="summary-entry-row">
            <div className="summary-entry-text">
              {walletTranslation?.maintanance
                ? walletTranslation?.maintanance
                : "Coin Maintanance Charge"}
            </div>
            <div className="summary-entry-value">
              {salesPrice ? yinnPercentage : 0}
            </div>
          </div>
          <div className="summary-entry-row">
            <div className="summary-entry-text">
              {shippingCartTranslation?.paymentFee
                ? shippingCartTranslation?.paymentFee
                : "Payment processing fees"}
            </div>
            <div className="summary-entry-value">
              {salesPrice ? (salesPrice * 0.029 + 0.3).toFixed(5) : 0}
            </div>
          </div>

          <div className="summary-separator"></div>

          <div className="summary-entry-row">
            <div className="summary-total-text">
              {orderTranslation?.total ? orderTranslation?.total : "Total"}
            </div>
            <div className="summary-total-text">
              {totalPrice ? totalPrice : 0}
            </div>
          </div>
          
          {/* Yncoin Purchase Policy Warning in Summary */}
          <div className="yncoin-policy-warning-summary">
            <div className="yncoin-policy-icon-summary">
              <i className="fa fa-exclamation-triangle"></i>
            </div>
            <div className="yncoin-policy-text-summary">
              {yncoinPolicyTranslations[userLanguage] || yncoinPolicyTranslations.en}
            </div>
          </div>
        </Col>
        <Col xs="0" sm="1"></Col>
      </Row>
    </div>
  );
};
export default Summary;
